<script>
import Layout from "../../layout/mainLayout";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import axios from 'axios';

/*
 * Add User
 */
export default {
  page: {
    title: "Add User",
    meta: [
      {
        name: "description",
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      name: "Add User",
      title: "Add User",
      items: [
        {
          text: "Users",
          href: "/users",
        },
      ],
      form: {
        email: "",
        mobile_phone: "",
        name: "",
      },
      errors: null,
      submitted: false,
      pending: false,
    };
  },
  validations: {
    form: {
      email: { required, email },
      name: { required },
      mobile_phone: { required },
    },
  },
  methods: {
    async addUser() {
      let that = this;
      that.$v.$touch();

      if (that.$v.$invalid) {
        window.scrollTo(0, 0);
        return;
      } else {
        that.submitted = true;
        let formData = new FormData();

        formData.append("name", that.form.name);
        formData.append("email", that.form.email);
        formData.append("mobile_phone", that.form.mobile_phone);
        await axios
          .post(appConfig.users.add, formData, that.headers)
          .then(function (res) {
            console.log(res);
            that.submitted = false;
            that.$iziToast.success({
              message: "Added Successfully!",
              position: "bottomCenter",
            });
            that.$router.push({ name: "Users" });
          })
          .catch(function (error) {
            that.submitted = false;
            if (error.response) {
              that.errors = error.response.data.errors;
              window.scrollTo(0, 0);
            }
          });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card" id="error_area">
          <div class="card-body">
            <FormValidation :errors="errors" />

            <form class="needs-validation" @submit.prevent="addUser">
              <fieldset :disabled="submitted || pending">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group mb-3">
                      <label for="name">Name</label>
                      <input
                        id="name"
                        type="text"
                        v-model="form.name"
                        class="form-control"
                        placeholder="Enter name"
                        :class="{ 'is-invalid': $v.form.name.$error }"
                      />
                      <div
                        v-if="!$v.form.name.required"
                        class="invalid-feedback"
                      >
                        Name is required
                      </div>
                    </div>

                    <div class="form-group mb-3">
                      <label for="mobile_phone">Mobile Number</label>
                      <input
                        id="mobile_phone"
                        v-model="form.mobile_phone"
                        type="text"
                        class="form-control"
                        :class="{ 'is-invalid': $v.form.mobile_phone.$error }"
                      />
                      <div
                        v-if="!$v.form.mobile_phone.required"
                        class="invalid-feedback"
                      >
                        Mobile Number is required
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group mb-3">
                      <label for="email">Email</label>
                      <input
                        id="email"
                        type="text"
                        v-model="form.email"
                        class="form-control"
                        :class="{ 'is-invalid': $v.form.email.$error }"
                      />
                      <div v-if="$v.form.email.$error" class="invalid-feedback">
                        <span v-if="!$v.form.email.required"
                          >Email is required</span
                        >
                        <span v-if="!$v.form.email.email"
                          >Email is invalid</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <!-- row -->
                <div class="col-lg-12 mt-4 text-right">
                  <button
                    class="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                  >
                    <span
                      v-show="submitted || pending"
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span v-show="!submitted && !pending">Save</span>
                  </button>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
